<template>
  <review-card-info-item :label="label">
    <span class="text text-h6 grey--text text--darken-2">
      <template v-if="isLoading">
        {{ count }}
      </template>
      <template v-else-if="numericCount > 0">
        {{ shortenedCount }}
      </template>
      <span v-else class="grey--text text--lighten-2">-</span>
    </span>
  </review-card-info-item>
</template>

<script>
import ReviewCardInfoItem from './ReviewCardInfoItem';

export default {
  name: 'ReviewCardInfoItemCount',
  components: { ReviewCardInfoItem },
  props: {
    label: {
      type: String,
      required: true,
    },
    count: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    isLoading() {
      return typeof this.count === 'string' && this.count === '...';
    },
    numericCount() {
      return typeof this.count === 'number' ? this.count : 0;
    },
    shortenedCount() {
      const value = this.numericCount;
      if (value < 1000) {
        return value;
      }
      return `${(value / 1000).toFixed(1)}k`;
    },
  },
};
</script>

<style scoped>
.text {
  line-height: unset !important;
}
</style>
